import React from 'react';
import { CatalogLayout } from './index';
import { useLayoutType, LayoutStyleTypes } from "@/util-react/layout";

/**
 * HOC для оборачивания страницы или компонента в CatalogLayout
 * @param Component - React компонент страницы
 * @param layoutType - тип layout: 'lg' (desktop) или 'sm' (mobile), по умолчанию 'sm'
 */
export function withCatalogLayout<T extends object>(Component: React.ComponentType<T>, layoutType: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM = LayoutStyleTypes.TYPE_SM) {
  return function WrappedWithCatalogLayout(props: T) {
    return (
      <CatalogLayout type={layoutType}>
        <Component {...props} />
      </CatalogLayout>
    );
  };
}
